import $x from '@/utils/$x';

export async function getUserList(params) {
  return $x.post('/contact/getContactDetailsPage', params);
}

export async function getUserFitnessReportList(params) {
  return $x.post('/sidebar/getUserFitnessReportList', params);
}

export async function getUserInfo(params) {
  return $x.post('/sidebar/getUserInfo', params);
}

export async function getWeekPerformList(params) {
  return $x.post('/sidebar/getWeekPerformList', params);
}

/// 客户列表
export async function getCustomerList(params) {
  return $x.post('/consumer/list', params);
}
/// 客户信息查询
export async function getInfo(params) {
  return $x.post('/consumer/getInfo', params);
}
/// 亲属关系下拉列表
export async function listRelatives(params) {
  return $x.post('/consumer/listRelatives', params);
}
/// 手机操作水平下拉列表
export async function listOperantLevels(params) {
  return $x.post('/consumer/listOperantLevels', params);
}
/// 档案问题列表
export async function listQuestions(params) {
  return $x.post('/consumer/listQuestions', params);
}
/// 保存亲属信息
export async function relativesSaveInfo(params) {
  return $x.post('/consumer/relatives/saveInfo', params);
}
/// 查询亲属信息
export async function relativesGetInfo(params) {
  return $x.post('/consumer/relatives/getInfo', params);
}
/// 获取跟进记
export async function getTrack(params) {
  return $x.post('/consumer/getTrack', params);
}
/// 保存或更新跟进记录
export async function saveTrack(params) {
  return $x.post('/consumer/saveTrack', params);
}
/// 删除跟进记录
export async function deleteTrack(params) {
  return $x.post('/consumer/deleteTrack', params);
}
/// 保存客户特征
export async function saveFeatureInfo(params) {
  return $x.post('/consumer/saveInfo', params);
}
/// 保存亲属特征
export async function saveRelativesFeatureInfo(params) {
  return $x.post('consumer/relatives/saveInfo', params);
}
/// 更换手机号
export async function palmerChangePhone(params) {
  return $x.post('/consumer/palmerChangePhone', params);
}
/// 获取国家代码
export async function listCountryCodeList(params) {
  return $x.post('/common/listCountryCodeList', params);
}
/// 跟进记录步骤列表
export async function listTrackSteps(params) {
  return $x.post('/consumer/listTrackSteps', params);
}
/// 权益消课记录列表
export async function revokePageList(params) {
  return $x.post('v1/litta/rights/revokePageList', params);
}
/// 手动权益消课
export async function optionalRevoke(params) {
  return $x.post('v1/litta/rights/optionalRevoke', params);
}
/// 客户档案-关联多人-绑定亲属关系
export async function bindingRelation(params) {
  return $x.post('/v1/litta/rights/bindingRelation', params);
}
/// 权益
export async function effAllRights(params) {
  return $x.post('/v1/litta/rights/effRightsByExerciseType', params);
}
/// 变更商家
export async function changeTenant(params) {
  return $x.post('/v1/litta/rights/changeTenant', params);
}
/// 用户上课课表
export async function getClassRoomList(params) {
  return $x.post('/consumer/getClassRoomList', params);
}
/// 获取神策事件列表
export async function listSensorsEvents(params) {
  return $x.post('/consumer/listSensorsEvents', params);
}
/// 删除亲属关系
export async function delRel(params) {
  return $x.post('/consumer/delRel', params);
}
/// 企业用户查询列表
export async function queryList(params) {
  return $x.post('/user/queryList', params);
}
/// 外部企业用户查询列表
export async function listExternalWeComUser(params) {
  return $x.post('/contact/listExternalWeComUser', params);
}
/// 分配员工
export async function userDistribution(params) {
  return $x.post('/consumer/userDistribution', params);
}

/// 分配员工
export async function serviceList(params) {
  return $x.post('/consumer/service/list', params);
}

/// 分配员工
export async function customerReplies(params) {
  return $x.post('/consumer/service/customerReplies', params);
}

/// 删除分配的用户
export async function deleteConsumer(params) {
  return $x.post('/consumer/service/deleteConsumer', params);
}

/// 未完成首课
export async function neverCompleteClass(params) {
  return $x.post('/consumer/service/neverCompleteClass', params);
}

/// 首课流失
export async function firstClassLoss(params) {
  return $x.post('/consumer/service/firstClassLoss', params);
}

/// 即将到期
export async function expiring(params) {
  return $x.post('/consumer/service/expiring', params);
}

/// 获取会话列表
export async function getChartList(params) {
  return $x.post('/rpaMessageCollection/queryMessageCollectionList', params);
}

/**
 * 根据 messageId 查询该消息**前面十条 + 后面十条**消息（含锚点自身，≈21 条，按时间正序）。
 * 入参：{ requestData: { messageId } } —— 群维度由服务端按锚点消息自身推导，无需传群ID。
 * 出参：BaseResponse<List<RpaMessageCollectionModel>>，data 为**裸数组**（不分页）。
 * ⚠ 该结果就是 ChatMessageItem 的输入形态：payload 已由服务端解析成对象，
 *   与 getChartList 的每一行同构。
 */
export async function queryMessageAroundMessageId(params) {
  return $x.post(
    '/rpaMessageCollection/queryWeChatMessageAroundMessageId',
    params,
  );
}

/// 获取会话Id内容
export async function getChartIdList(params) {
  return $x.post('/rpaMessageCollection/getGroupChatListByUser', params);
}

/// 获取商家会话Id内容
export async function getGroupChatListByTenant(params) {
  return $x.post('/tenantGroup/getGroupChatListByTenant', params);
}

/// 手动发送RPA信息
export async function manualSendRpaMessage(params) {
  return $x.post('/rpaMessageCollection/manualSendRpaMessage', params);
}

/// 用户档案———概览页
export async function userOverview(params) {
  return $x.post('/consumer/userOverview', params);
}

/// 用户档案———已加企微
export async function alreadyAddWxUser(params) {
  return $x.post('/consumer/alreadyAddWxUser', params);
}

/// 用户档案———已加服务群
export async function alreadyAddServiceGroup(params) {
  return $x.post('/consumer/alreadyAddServiceGroup', params);
}

/// 用户档案———已加打卡群
export async function alreadyAddDailyGroup(params) {
  return $x.post('/consumer/alreadyAddDailyGroup', params);
}

/// 用户档案———地理位置
export async function location(params) {
  return $x.post('/consumer/location', params);
}

/// 用户档案———运动动作
export async function sportAction(params) {
  return $x.post('/consumer/sportAction', params);
}

/// 运动提醒设置
export async function queryNotifyContentWithInit(params) {
  return $x.post('/consumer/queryNotifyContentWithInit', params);
}

/// 保存运动提醒设置
export async function setNotifyContent(params) {
  return $x.post('/consumer/setNotifyContent', params);
}

/// 用户档案———设置专属服务群
export async function setServiceGroupExclusive(params) {
  return $x.post('/consumer/setServiceGroupExclusive', params);
}

/// 用户档案———公众号关注记录
export async function subrecord(params) {
  return $x.post('/consumer/subrecord', params);
}

/// 用户档案———一起练记录
export async function togetherrecord(params) {
  return $x.post('/consumer/togetherrecord', params);
}

/// 用户档案———自动续费签约记录
export async function renewrecord(params) {
  return $x.post('/consumer/renewrecord', params);
}

/// 用户档案———触达记录
export async function userActionRecord(params) {
  return $x.post('/consumer/userActionRecord', params);
}

/// 用户档案———用户空间信息
export async function getSpaceInfo(params) {
  return $x.post('/consumer/getSpaceInfo', params);
}
/// 用户档案———全身入镜数据
export async function queryUserMoment(params) {
  return $x.post('/consumer/queryUserMoment', params);
}
/// 用户档案———家庭卡共享数据
export async function queryUserPool(params) {
  return $x.post('/consumer/queryUserFamilyByRights', params);
}
/// 用户档案———空间关注数据
export async function queryUserFollowing(params) {
  return $x.post('/consumer/queryUserFollowing', params);
}
/// 用户档案———空间粉丝数据
export async function queryUserFollowed(params) {
  return $x.post('/consumer/queryUserFollowed', params);
}
/// 用户档案———空间的打卡数据
export async function queryUserSpace(params) {
  return $x.post('/consumer/queryUserSpace', params);
}
/// 用户档案———所属教练
export async function userOverviewCoach(params) {
  return $x.post('/consumer/userOverview/coach', params);
}
/// 批量导入白名单用户
export async function whiteUserImport(params) {
  return $x.post('/white/user/import', params);
}
/// 白名单列表
export async function whiteUserList(params) {
  return $x.post('/white/user/list', params);
}
/// 白名单列表
export async function whiteUserDelBatch(params) {
  return $x.post('/white/user/delBatch', params);
}
/// 白名单列表
export async function whiteUserAdd(params) {
  return $x.post('/white/user/add', params);
}
/// 白名单列表
export async function modifyIfSettlement(params) {
  return $x.post('/white/user/modifyIfSettlement', params);
}

/// 修改白名单用户C-C转介绍类型
export async function modifyCcType(params) {
  return $x.post('/white/user/modifyCcType', params);
}
/// 分页查询奖励金领取记录
export async function rewardRecordPage(params) {
  return $x.post('/consumer/rewardRecordPage', params);
}
/// 分页查询周期约课操作记录 ID：e24gQY3z
export async function periodAppointLogPage(params) {
  return $x.post('/consumer/periodAppointLogPage', params);
}
/// 分页查询用户周计划操作记录
export async function weekPlanRecordPage(params) {
  return $x.post('/consumer/weekPlanRecordPage', params);
}
/// 用户档案———LITTA点播
export async function contentPlayRecordPageList(params) {
  return $x.post('/consumer/contentPlayRecordPageList', params);
}
/// 用户档案———打卡数
export async function userClockNum(params) {
  return $x.post('/consumer/clockNum', params);
}
/// 用户档案———打卡数
export async function userClockData(params) {
  return $x.post('/consumer/clockInData', params);
}
// 请求ai信息
export async function sendAiAnalyse(params) {
  return $x.post('/consumer/chat/send/analyse', params);
}
// 请求ai信息
export async function pageList(params) {
  return $x.post('/group/chat/summary/pageList', params);
}
// 获取ai信息
export async function getAiAnalyseInfo(params) {
  return $x.post('/consumer/chat/info/analyse', params);
}

/// 获取群数据分析
export async function getGroupAnalysisData(params) {
  return $x.post('/chat/data/list', params);
}

/// 获取用户画像数据
export async function getUserPortrait(params) {
  return $x.post('/user/info/portrait', params);
}

// 获取用户详情资料
export async function getUserProfile(params) {
  return $x.post('/user/info/profile', params);
}

// 用户档案———微信绑定关系列表
export async function getManagedAllGroupChatMembers(params) {
  return $x.post('/wxGroupChat/queryManagedAllGroupChatMembers', params);
}
// 切换微信绑定关系
export async function switchWechatBind(params) {
  return $x.post('/wxGroupChat/switchWechatBind', params);
}

// 树洞会话列表
export async function pageConversationList(params) {
  return $x.post('/consumer/treehole/pageConversationList', params);
}

// 查询指定会话的聊天记录
export async function getConversationChatRecordList(params) {
  return $x.post('/consumer/treehole/getConversationChatRecordList', params);
}

// 获取用户变化类型列表
export async function getChangeTypes(params) {
  return $x.get('/changes/types', params);
}

// 分页查询用户变化数据列表
export async function getChangesList(params) {
  return $x.post('/changes/list', params);
}

// 根据ID查询体态变化详情
export async function getPostureChangeDetail(params) {
  return $x.post('/changes/detail/posture', params);
}

// 根据ID查询运动能力变化详情
export async function getSportAbilityChangeDetail(params) {
  return $x.post('/changes/detail/sportAbility', params);
}

// 获取用户记忆体数据
export async function getUserMemory(params) {
  return $x.post('/memory/getUserMemory', params);
}

export async function getUserMemoryData(params) {
  return $x.post('/memory/getUserMemoryData', params);
}

// 导出聊天记录
export async function exportChatHistory(params) {
  return $x.post('/rpaMessageCollection/exportWxGroupChatMessage', params);
}

// 获取聊天记录导出任务
export async function getChatExportRecords(params) {
  return $x.post(
    '/rpaMessageCollection/exportWxGroupChatMessageRecords',
    params,
  );
}
